import React from "react";
import AccountOverview from "./MultiCurrencyBank/index.js";
import { useOverview } from "../hooks";
import TransactionOverView from "./Transaction/index.jsx";
import ProtectedLayout from "./../Components/Navbar/ProtectedNavbar.jsx";
import BackToUnified from "./../Components/sideBar/backToUnified.js";
// import BorderlessMoneyBanner from "./../Components/BorderlessMoneyBanner/index.js";

const TabNavigation = () => {
  const { noPayment, setIsOpen, activeTab, setActiveTab, setCurrentFlow } =
    useOverview();

  const nav = {
    className: "border-b border-gray-300",
    "aria-label": "Tabs",
    buttons: [
      {
        text: "Account Overview",
        activeTab: "overview",
        onClick: () => setActiveTab("overview"),
      },
      {
        text: "Transactions",
        activeTab: "transactions",
        onClick: () => setActiveTab("transactions"),
      },
    ],
  };

  return (
    <ProtectedLayout>
      {/* <BorderlessMoneyBanner /> */}
      <div className="w-full mt-[63px] lg:mt-[80px] overflow-auto ">
        {/* Tab List */}
        <div className=" flex  justify-around  xs:justify-start z-50  xs:px-6 xl:!px-40 items-end border-b  bg-greyShade h-[51px] lg:h-16">
          {nav.buttons?.map((button, index) => (
            <button
              key={index}
              className={`relative py-4 mr-6 text-blackShade text-base font-geomanistBold ${
                activeTab === button.activeTab
                  ? "text-black"
                  : "hover:text-gray-500"
              }`}
              onClick={button.onClick}
            >
              {button.text}
              <span
                className={`absolute left-0 right-0 bottom-0 h-[3px] mx-2 transition-all duration-300 ${
                  activeTab === button.activeTab
                    ? "bg-blueish"
                    : "bg-transparent"
                }`}
              />
            </button>
          ))}
        </div>


        {/* Tab Content */}
        {activeTab === "overview" && (
          <AccountOverview
            noPayment={noPayment}
            setIsOpen={setIsOpen}
            setCurrentFlow={setCurrentFlow}
          />
        )}
        {activeTab === "transactions" && <TransactionOverView />}
      </div>
      <BackToUnified />
    </ProtectedLayout>
  );
};

export default TabNavigation;
